import React from 'react';
import './AreaIndicatorLastSample.css';

import { Box } from '@mui/material';
import { getCurrentObjective } from '../helper';
import { generateClassName, toLocaleDateTime } from '../../../b2b-common/helpers';

const AreaIndicatorLastSample = ({
    areaIndicatorData,
    showLastSampleDate = true,
    referenceDate = null,
    className = null
}) => {

    if (!areaIndicatorData) return null;
    const currentObjective = areaIndicatorData.objectiveDTOs ? getCurrentObjective(areaIndicatorData.objectiveDTOs, referenceDate) : null;
    const indicatorDTO = areaIndicatorData.indicatorDTO;
    const lastOfAllSamples = areaIndicatorData.lastSample;

    console.log('AreaIndicatorLastSample', areaIndicatorData, currentObjective, lastOfAllSamples);
    
    if (!indicatorDTO) return null;
    if (!indicatorDTO.indicatorDTOType === 'QUANTITATIVE') return null;

    const lastSampleToBeUsedDate = currentObjective && currentObjective.lastSample
        ? currentObjective.lastSample.sampleDate
        : lastOfAllSamples && lastOfAllSamples.sampleDate ? lastOfAllSamples.sampleDate : null;
    const lastSampleToBeUsed = currentObjective && currentObjective.lastSample
        ? currentObjective.lastSample.quantitativeValue
        : lastOfAllSamples && lastOfAllSamples.quantitativeValue != null ? lastOfAllSamples.quantitativeValue : null;

    // Determine font size class based on number length
    const getNumberSizeClass = (value) => {
        if (value == null) return '';
        const valueString = value.toString();
        if (valueString.length > 9) return 'tiny';
        if (valueString.length > 6) return 'extra-small';
        if (valueString.length > 4) return 'small';
        return '';
    };

    const numberSizeClass = getNumberSizeClass(lastSampleToBeUsed);

    // In the absence of a last sample at the objective level, we will show the last sample at the indicator level.

    return (
        <Box className={generateClassName('area-indicator-last-sample','',className)} display={'flex'} flexDirection={'column'} 
            width={'100%'} position={'relative'} boxSizing={'border-box'} >
            {showLastSampleDate && (
                <Box className='area-indicator-last-sample-date' display={'flex'} flexDirection={'row'} width={'100%'}  > 
                    {toLocaleDateTime(lastSampleToBeUsedDate, false)}
                </Box>
            )}
            <Box className='area-indicator-last-sample-value'
                display={'flex'} flexDirection={'row'} width={'100%'} p={0} gap={1} boxSizing={'border-box'} 
                justifyContent={'center'} alignItems={'flex-end'}
            >
                <Box className={`area-indicator-last-sample-value-number ${numberSizeClass}`} width={'55%'} >
                    {lastSampleToBeUsed}
                </Box>
                <Box className='area-indicator-last-sample-measurement-unit' width={'45%'} >
                    {indicatorDTO.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit}
                </Box>
            </Box>
        </Box>
    );
}

export default AreaIndicatorLastSample;